<template>
<div>
  <article class="article project" v-if="active">
    <header class="article-header">
      <figure>
        <img 
          v-if="post['featured_image']" 
          :data-src="post['featured_image'].src" 
          :data-srcset="post['featured_image'].srcset"
          :alt="post.title.rendered"
          class="lazyload lazy-fade"
          >
      </figure>
      <h1 class="page-title">{{post.title.rendered}}</h1>
      <div class=work-info>
        <span class="description" v-if="post.acf.description">{{post.acf.description}}</span>
        <span class="year">{{post.acf.year}}</span>
      </div>
      <ul class="tags" v-if="tagLoaded">
        <li class="tag" 
        v-for="tag in post.tags"
        :key="tag">
        <router-link
          :to="{name:'Work', hash:'#'+getTagSlugById(tag)}">
        {{getTagById(tag)}}
        </router-link></li>
      </ul>
    </header>
    <main 
      class="content" 
      v-html="post.content.rendered"
      >
    </main>
  </article>

  <a href="#related-posts" v-if="active" v-onlazy="handleScroll"></a>
  <section class="related-posts" v-if="showRelatedPosts">
    <h2>RELATED WORK</h2>
    <Archive 
      name="post"
      routeName="WorkDetail" 
      :filterTags="post.tags"
      :excludeId="post.id"
      :length="3"
      ></Archive>

  </section>
</div>
</template>


<style lang="scss" scoped>

.article-header{

  text-align: center;
}

.page-title{
  padding-bottom:0px;
  margin-bottom:10px
}

.tags{
  color: #999;
  font-size: 80%;
  .tag{
    padding:0;
  }
}

.content{
  margin-top: 40px;
}
</style>

<script>

import PageData from '@/mixins/PageData'
import Archive from '../components/Archive'


export default {
  components:{Archive},
  mixins:[PageData],
  data:()=>({
    post:null,
    active:false,
    tags:null,
    tagIds:null,
    tagLoaded:false,
    showRelatedPosts:false,
    
  }),
  watch: {
    $route (to) {
      //同一ページへの移動の場合
      this.updatePage(to.params.name);
    }
  },
  methods:{
    
    updatePage(name){
      this.active = false;
      this.pageLoading()

      this.getPost('posts',name)
      .then(data =>{
          this.post = data;
          this.active = true;

          this.pageLoaded()
      })

      this.getTags('post').then(data=>{
        this.tags = data;
        this.tagLoaded = true;
      })

    },

    getTagById(id){
      return (this.tags) ? this.tags.filter(d => d.id==id)[0]['name'] : false
    },
    getTagSlugById(id){
      return (this.tags) ? this.tags.filter(d => d.id==id)[0]['slug'] : false
    },

    handleScroll: function (/*evt, el*/) {
      this.showRelatedPosts = true
      // console.log("scrolled",evt,el)
      return true
    }
  },
  mounted(){

    this.updatePage(this.$route.params.name);
  }
}
</script>